exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pendingFriendsCard-c9938594>div{margin-bottom:10px}.pendingFriendsCard-c9938594>div:last-child{margin-bottom:0px}.request-25afa8d9{width:100%;display:flex}.user-a9eb0a71{width:100%;display:flex;flex-flow:row wrap;padding-left:20px}.name-260967a5{width:100%}.buttons-2c8f8354,.buttons-2c8f8354:visited,.buttons-2c8f8354:active,.buttons-2c8f8354:focus{display:flex;justify-content:space-between;font-size:13px;line-height:15px;font-weight:500}.buttons-2c8f8354 .right-5d6130db,.buttons-2c8f8354:visited .right-5d6130db,.buttons-2c8f8354:active .right-5d6130db,.buttons-2c8f8354:focus .right-5d6130db{padding-left:20px}\n", ""]);

// Exports
exports.locals = {
	"pendingFriendsCard": "pendingFriendsCard-c9938594",
	"request": "request-25afa8d9",
	"user": "user-a9eb0a71",
	"name": "name-260967a5",
	"buttons": "buttons-2c8f8354",
	"right": "right-5d6130db"
};